import { Button } from '@material-tailwind/react';
import React from 'react';
import { IPlaylistItem } from '../interfaces/youtube';

export const Hero: React.FC<{
  playlistItem: IPlaylistItem;
  isLiveEvent: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ playlistItem, isLiveEvent, setOpenDialog }) => {
  return (
    <>
      <div className="grid place-content-center gap-8 w-full relative  mt-5 pb-16 md:pb-[200px]">
        <div className="w-full flex justify-center">
          <div className="w-full md:max-w-[720px]">
            <h1 className="text-center text-secondary text-6xl font-bold mb-4">
              {playlistItem?.snippet?.title}
            </h1>
            <p className="text-sm text-gray-500">{playlistItem?.snippet?.description}</p>
          </div>
        </div>

        <div className="w-full">
          <div className="flex justify-center">
            {isLiveEvent ? (
              <>
                <Button
                  className="rounded bg-primary"
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                  onClick={() => setOpenDialog(true)}
                >
                  Register
                </Button>
              </>
            ) : (
              <>
                <Button
                  className="rounded bg-primary"
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                  onClick={() => setOpenDialog(true)}
                >
                  Request video
                </Button>
              </>
            )}
          </div>
        </div>
        {/* video */}
        <div className="w-full  flex justify-center z-10">
          <div
            className="w-full relative h-[525.42px] bg-[#242732] rounded cursor-pointer"
            onClick={() => setOpenDialog(true)}
          >
            <img
              className="object-contain md:object-cover w-full h-full "
              src={playlistItem?.snippet?.thumbnails.high.url}
              alt=""
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="48"
                height="48"
                viewBox="0 0 48 48"
              >
                {' '}
                <path
                  fill="#FF3D00"
                  d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"
                ></path>
                <path fill="#FFF" d="M20 31L20 17 32 24z"></path>{' '}
              </svg>
            </div>
          </div>
        </div>

        {/* banner */}
        <div className="w-100 absolute bottom-0 z-0">
          <img src="/images/banner.svg" alt="banner" />
        </div>
      </div>
    </>
  );
};
